export default __webpack_public_path__ + "static/media/photo_2022-01-28_22-43-50.1ff82bbc.jpg";